import Modal from "../../../../components/Modal";
import { useUpsertConvenio } from "../hooks/useConvenio";
import ConvenioForm from "./ConvenioForm";

const CriarConvenio = ({ children }) => {
  const { mutateAsync, isPending } = useUpsertConvenio();

  return (
      <Modal
        trigger={({ onOpen }) => (
          <>
            {typeof children === 'function' ? children({ onOpen }) : children}
          </>
        )}
        title="Cadastro Convênio"
        size="5xl"
        responsive
        formId="form-convenio"
        isLoading={isPending}
      >
        {({ onClose }) => (
          <ConvenioForm
            onSubmit={async (data) => { await mutateAsync(data); onClose(); }}
            isLoading={isPending}
            formId="form-convenio"
            hideActions
          />
        )}
      </Modal >
  );
};

export default CriarConvenio;
